export const USER_PROFILE_TAB_DOCUMENTS_BREADCRUMB_USER = 'user'

export const USER_PROFILE_TAB_DOCUMENTS_QA_NAME = 'user_profile_documents'
